// 系统设置=>部门管理
import request from '@/plugins/axios'

const API_LIST = {
  DEPARTMENT_LIST: '/department/listDepartment',   //部门查询
  DEPARTMENT_ADD: '/department/addDepartment',    //新增部门
  DEPARTMENT_UPDATE: '/department/updateDepartment', //修改部门
  DEPARTMENT_UPDATE_STATUS: '/department/updateStatus', //修改部门状态

  DEPARTMENT_COUNT_LIST: '/department/uploadResources',   //部门数据查询
  DEPARTMENT_SHARE_LIST: '/department/shareResources' ,//部门共享资源信息统计
  DEPARTMENT_WEARHOUSE_LIST: '/department/warehouseResources' ,//部门共享入库资源信息统计
}
//获取部门列表
export function getDepartmentListApi(params) {
  return request({ url: API_LIST.DEPARTMENT_LIST, method: 'get', params})
}

//首页获取部门上传统计量
export function getDepartmentCountListApi(params) {
  return request({ url: API_LIST.DEPARTMENT_COUNT_LIST, method: 'get', params})
}

//获取部门共享资源统计量
export function getDepartmentShareListApi(params) {
  return request({ url: API_LIST.DEPARTMENT_SHARE_LIST, method: 'get', params})
}

//部门共享入库资源信息统计
export function getDepartmentWearHouseListApi(params) {
  return request({ url: API_LIST.DEPARTMENT_WEARHOUSE_LIST, method: 'get', params})
}



//新增部门
export function addDepartmentApi(data) {
  return request({ url: API_LIST.DEPARTMENT_ADD, method: 'post', data})
}

//修改部门信息
export function updateDepartmentApi(data) {
  return request({ url: API_LIST.DEPARTMENT_UPDATE, method: 'post', data})
}

//修改部门状态
export function updateDepartmentStatusApi(data) {
  return request({ url: API_LIST.DEPARTMENT_UPDATE_STATUS, method: 'post', data})
}
